import { createGlobalStyle } from 'styled-components'

const BodyOverflowHidden = createGlobalStyle`
  body {
    overflow: hidden;
  }
`

export { BodyOverflowHidden }
